import React, { useState } from "react";
import { isEmpty, orderBy } from "lodash";
// components
import {
    Accordion,
    AccordionBody,
    AccordionHeader,
    AccordionItem,
  } from 'reactstrap';
// type
import { TMainPageLayoutV3 } from "../type";
import TLanguageVersionList from "@/cms/types/TLanguageVersionList";
// enums
import EViewType from "@/cms/enums/EViewType";
// utilities
import RMDRComponentSanitizer from "@/components/RMDRComponentSanitizer";


const MNPG057 = ( props: TMainPageLayoutV3 ) => {
    console.log("MNPG057.rendered: ", props);
    
    const [activeAccordion, setActiveAccordion] = useState<string>("");

    const toggle = (id:string) => {
        if (activeAccordion !== id) setActiveAccordion(id);
    }

    if ( 
        !isEmpty(props.params?.parentLanguageVersion) && props.params?.parentLanguageVersion && 
        !isEmpty(props.params?.parentLanguageVersion?.id) && props.params?.parentLanguageVersion?.id && 
        props.params?.parentLanguageVersion?.viewType === EViewType.ACCORDION 
    ) {
        let payloadChild:TLanguageVersionList[]|null = props.params?.languageVersions?.filter((item:TLanguageVersionList) => item.parentId === props.params?.parentLanguageVersion?.id);

        if ( isEmpty(payloadChild) ) return null;

        payloadChild = orderBy(payloadChild, ['order'],['asc']);
        if ( isEmpty(activeAccordion) ) setActiveAccordion(payloadChild[0].id);

        return (
            <Accordion open={activeAccordion} toggle={toggle}>
                {
                    payloadChild.map((item) => (
                        <AccordionItem>
                            <AccordionHeader targetId={item.id}>{item.name}</AccordionHeader>
                            <AccordionBody accordionId={item.id}>
                                <RMDRComponentSanitizer
                                    languageVersion={item}
                                    variant="div"
                                    valueExpr="value"
                                    removeTag
                                />
                            </AccordionBody>
                        </AccordionItem>
                    ))
                }
            </Accordion>
        )
    }

    return null;
}

export default MNPG057;
